import React, { useState } from 'react';
import {
  Box,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Typography
} from '@mui/material';

const flightData = [
  { id: 1, name: 'IndiGo 6E-205' },
  { id: 2, name: 'Air India AI-101' },
  { id: 3, name: 'SpiceJet SG-302' },
  { id: 4, name: 'Vistara UK-857' },
];

const percentageOptions = Array.from({ length: 10 }, (_, i) => i + 1); // 1 to 10

type Data = {
  id: number;
  name: string;
};

const initialRows: Data[] = [
  { id: 1, name: 'IndiGo 6E-205' },
  { id: 2, name: 'Air India AI-101' },
  { id: 3, name: 'SpiceJet SG-302' },
  { id: 4, name: 'Vistara UK-857' },
];

const TrackFare = () => {
    const [rows, setRows] = useState<Data[]>(initialRows);
    const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
      const [page, setPage] = useState(0);
      const [rowsPerPage, setRowsPerPage] = useState(10);

      const handleChangePage = (_: unknown, newPage: number) => {
          setPage(newPage);
        };
      
        const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
          setRowsPerPage(+event.target.value);
          setPage(0);
        };

    const [pricing, setPricing] = useState(
    flightData.map(flight => ({
      id: flight.id,
      markup: '',
      discount: ''
    }))
  );

  const handleChange = (id: number, field: 'markup' | 'discount', value: string | number) => {
    setPricing(prev =>
      prev.map(item =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  return (
    <>
    <Box className="headingBtnWrap">
      <Typography variant="h1">Track Fare</Typography>
    </Box>
    <Box component="form" className="roleWrap">
        <div className="form-control inputFieldWrap">
            <label>User</label>
            <Select
            labelId="role-select-label"
            id="role-select"
            className='inputField'
            displayEmpty
            defaultValue=""
            >
        <MenuItem value="">Select User</MenuItem>
        <MenuItem value="admin">Aman</MenuItem>
        <MenuItem value="editor">Rahul</MenuItem>
        <MenuItem value="viewer">Harmeet</MenuItem>
        <MenuItem value="guest">Samarth</MenuItem>
        </Select>
        </div>
    </Box>
    <Box className="feeInputFieldWrap">
        <Box component="form" className="modalForm">
            <div className="form-control inputFieldWrap">
                <label>From</label>
                <input type="text" className='inputField' />
            </div>
            <div className="form-control inputFieldWrap">
                <label>Destination</label>
                <input type="text" className='inputField' />
            </div>
            <div className="form-control inputFieldWrap smallWidth">
                <label>Internal Search</label>
                <input type="text" className='inputField' />
            </div>
            <div className="form-control inputFieldWrap smallWidth">
                <label>External Search</label>
                <input type="text" className='inputField' />
            </div>
        </Box>
    </Box>
    <Paper sx={{ width: '100%', overflowX: 'auto', mt: 4 }}>
    <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader>
          <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
            <TableRow>
              <TableCell><strong>Markup</strong></TableCell>
              <TableCell><strong>Discount</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {flightData.map(flight => {
              const row = pricing.find(p => p.id === flight.id) || { markup: '', discount: '' };
              return (
                <TableRow key={flight.id}>
                  <TableCell>
                    <Select
                      value={row.markup}
                      onChange={e => handleChange(flight.id, 'markup', e.target.value)}
                      displayEmpty
                      className='selectChoose'
                    >
                      <MenuItem value="" disabled>Select Markup</MenuItem>
                      {percentageOptions.map(p => (
                        <MenuItem key={p} value={p}>{p}%</MenuItem>
                      ))}
                    </Select>
                  </TableCell>
                  <TableCell>
                    <Select
                      value={row.discount}
                      onChange={e => handleChange(flight.id, 'discount', e.target.value)}
                      displayEmpty
                      className='selectChoose'
                    >
                      <MenuItem value="" disabled>Select Discount</MenuItem>
                      {percentageOptions.map(p => (
                        <MenuItem key={p} value={p}>{p}%</MenuItem>
                      ))}
                    </Select>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
                </Paper>
    </>
  )
}

export default TrackFare
